import React from "react";
import BuySetCell from "./BuySetCell";
import RuneSet from "../misc/RuneSet";
import SkillOrder from "../misc/SkillOrder";
import styles from "./MatchExtraDetails.module.css";

const MatchExtraDetails = ({ match, pid, width }) => {
  return (
    <div className={styles.wrapper}>
      <div>
        {Object.keys(match.build[pid]).map((time, i) => (
          <BuySetCell key={i} time={time} set={match.build[pid][time]} />
        ))}
      </div>
      <div className={styles["row2_" + width]}>
        <SkillOrder
          skills={parseInt(match.skill[pid])}
          cid={match.champion[pid]}
          type="dark"
        />
        <div className={styles["runes_" + width]}>
          <RuneSet
            runePage={match.perkPrimaryStyle[pid]}
            active={[
              match.perk0[pid],
              match.perk1[pid],
              match.perk2[pid],
              match.perk3[pid],
            ]}
            primary={true}
          />
          <RuneSet
            runePage={match.perkSubStyle[pid]}
            active={[match.perk4[pid], match.perk5[pid]]}
            primary={false}
          />
          <RuneSet
            runePage="statMod"
            active={[
              match.statPerk0[pid],
              match.statPerk1[pid],
              match.statPerk2[pid],
            ]}
            primary={false}
          />
        </div>
      </div>
    </div>
  );
};

export default MatchExtraDetails;
